
import request from '@/utils/request'

export function createUpdate (data) {
    return request({
        url: '/backend/activity/luminary/createUpdate',
        method: 'post',
        data: data
    })
}
// activity/luminary/getInfo
export function getInfo (data) {
    return request({
        url: '/backend/activity/luminary/getInfo',
        method: 'post',
        data: data
    })
}
// 发光者用户列表
export function userlist (data) {
  return request({
      url: '/backend/activity/luminary/user/list',
      method: 'post',
      data: data
  })
}

export function authentication (data) {
  return request({
      url: '/backend/activity/luminary/user/authentication/info',
      method: 'post',
      data: data
  })
}

export function examine (data) {
  return request({
      url: '/backend/activity/luminary/user/authentication/examine',
      method: 'post',
      data: data
  })
}

export function getWithdrawList (data) {
  return request({
      url: '/backend/activity/luminary/getWithdrawList',
      method: 'post',
      data: data
  })
}

export function exportWithdrawList (data) {
  return request({
      url: '/backend/activity/luminary/exportWithdrawList',
      method: 'post',
      data: data
  })
}

export function withdrawAudit (data) {
  return request({
      url: '/backend/activity/luminary/withdrawAudit',
      method: 'post',
      data: data
  })
}

export function promoterlist (data) {
  return request({
      url: '/backend/activity/luminary/promoter/list',
      method: 'post',
      data: data
  })
}
// export function advancePlanCourseList (data) {
//     return request({
//         url: '/backend/course/advance-plan/course/list',
//         method: 'get',
//         params: data
//     })
// }
// backend/activity/luminary/user/authentication/infoUpdate 

export function infoUpdate (data) {
  return request({
      url: '/backend/activity/luminary/user/authentication/infoUpdate',
      method: 'post',
      data: data
  })
}

export function getRevenueLogList (data) {
  return request({
      url: '/backend/activity/luminary/getRevenueLogList',
      method: 'post',
      data: data
  })
}

// 获取提现配置
export function getWithdrawConfig(data) {
  return request({
    url: '/backend/activity/luminary/getWithdrawConfig',
    method: 'post',
    data: data
  })
}

// 保存提现配置
export function saveWithdrawConfig(data) {
  return request({
    url: '/backend/activity/luminary/saveWithdrawConfig',
    method: 'post',
    data: data
  })
}